import React from 'react';
import {
  CardHeader,
} from 'reactstrap';
import PropTypes from 'prop-types';
import GA4React from 'ga-4-react';
import SocialButton from './SocialButton';
import { fetch } from '../index/move-blocks';

const propTypes = {
  onLogin: PropTypes.func.isRequired,
};

const defaultProps = {
};

class SignupForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      googleLoading: false,
    };
    this.handleSocialLogin = this.handleSocialLogin.bind(this);
    this.handleSocialLoginFailure = this.handleSocialLoginFailure.bind(this);
  }

  handleSocialLogin(socialUser) {
    const { provider } = socialUser;
    const body = JSON.stringify({
      access_token: socialUser.token.accessToken,
      code: socialUser.code,
    });
    const options = {
      method: 'POST',
      body,
      mode: 'cors',
      cache: 'default',
      credentials: 'include',
    };
    fetch(`/api/auth/${provider}`, options).then((r) => {
      const data = {};
      data[`${provider}Loading`] = false;

      r.json().catch(() => {
        this.setState(data);
        this.onMessage('Was problem on login');
        return false;
      }).then((user) => {
        if (user) {
          if (GA4React.isInitialized()) {
            const userId = localStorage.getItem('userId') || Math.random();
            localStorage.setItem('userId', userId);

            const ga4react = new GA4React('G-T5CE4LGSJ6', {
              user_id: userId,
            });
            ga4react.event('signup', provider, 'engagement');
          }
          this.setState(data, () => {
            const { props } = this;
            props.onLogin({ isAuthenticated: true, user });
          });
        }
      });
    });
  }

  handleSocialLoginFailure() {
    const { props } = this;
    props.onMessage('Was a problem!');
  }

  render() {
    const { props } = this;
    const { state } = this;
    const { title } = props;
    const { facebookLoading, googleLoading } = state;
    return (
      <CardHeader>
        <h1>{title}</h1>
        <div className="social_icon">
          <SocialButton
            self={this}
            provider="facebook"
            loading="facebookLoading"
            appId="527960067241629"
            onLoginSuccess={this.handleSocialLogin}
            onLoginFailure={this.handleSocialLoginFailure}
          >
            <span>
              <i className={`${facebookLoading ? 'fas fa-spinner spin-animate' : 'fab fa-facebook'}`} />
              {' '}
              Login with Facebook
            </span>
          </SocialButton>
          <SocialButton
            className="google"
            self={this}
            provider="google"
            loading="googleLoading"
            appId="863297292231-44d98nvvutu716no8srn8enq1re23udu.apps.googleusercontent.com"
            onLoginSuccess={this.handleSocialLogin}
            onLoginFailure={this.handleSocialLoginFailure}
          >
            <span>
              <i className={`${googleLoading ? 'fas fa-spinner spin-animate' : 'fab fa-google-plus'}`} />
              {' '}
              Login with Google
            </span>
          </SocialButton>
        </div>
        <h2>- or -</h2>
      </CardHeader>
    );
  }
}

SignupForm.propTypes = propTypes;
SignupForm.defaultProps = defaultProps;

export default SignupForm;
